import { render, staticRenderFns } from "./EditPremiumService.vue?vue&type=template&id=98d60b24&scoped=true"
import script from "./EditPremiumService.ts?vue&type=script&lang=ts&external"
export * from "./EditPremiumService.ts?vue&type=script&lang=ts&external"
import style0 from "./EditPremiumService.scss?vue&type=style&index=0&id=98d60b24&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d60b24",
  null
  
)

export default component.exports